var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.31239 7.14191C7.66686 7.14191 7.14355 7.66521 7.14355 8.31074C7.14355 8.95627 7.66686 9.47957 8.31239 9.47957H9.85229L14.5962 21.603L13.607 25.5597C13.5197 25.9089 13.5982 26.2788 13.8197 26.5625C14.0412 26.8462 14.381 27.012 14.741 27.012H28.1825C28.8281 27.012 29.3514 26.4887 29.3514 25.8432C29.3514 25.1977 28.8281 24.6744 28.1825 24.6744H16.238L16.7708 22.5432C16.8289 22.4798 16.8795 22.4105 16.9221 22.3367H27.0137C27.4564 22.3367 27.8611 22.0866 28.0591 21.6906L32.7344 12.3399C32.9156 11.9776 32.8962 11.5473 32.6833 11.2027C32.4703 10.8582 32.0941 10.6484 31.689 10.6484H12.8199L11.7385 7.88482C11.5632 7.43675 11.1312 7.14191 10.65 7.14191H8.31239ZM26.2913 19.9991H16.4789L13.7347 12.9861H29.7978L26.2913 19.9991Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.663 30.5185C17.663 31.8096 16.6164 32.8562 15.3254 32.8562C14.0343 32.8562 12.9877 31.8096 12.9877 30.5185C12.9877 29.2275 14.0343 28.1809 15.3254 28.1809C16.6164 28.1809 17.663 29.2275 17.663 30.5185Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3513 30.5185C29.3513 31.8096 28.3047 32.8562 27.0137 32.8562C25.7226 32.8562 24.676 31.8096 24.676 30.5185C24.676 29.2275 25.7226 28.1809 27.0137 28.1809C28.3047 28.1809 29.3513 29.2275 29.3513 30.5185Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCart);
export default __webpack_public_path__ + "static/media/IconCart.3b89431e216278e6a7a32547e1c7ab92.svg";
export { ForwardRef as ReactComponent };